import React, { useEffect, useState } from "react";
import PayHere from "./PayHere";
import PropTypes from "prop-types";
import styles from "./styles.module.css";
import OverviewTab from "./OverviewTab";
import ManagePaymentTab from "./ManagePaymentTab";
import { connect } from "react-redux";
import {
  getSubscriptionUser,
  getSubscriptionDetails,
  getAllPaymentHistoryforCompany,
} from "../actions";
import { useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import MembershipTab from "./MembershipTab";

const serviceId = process.env.REACT_APP_SERVICE_ID;

const Payment = ({
  getSubscriptionDetails,
  getAllPaymentHistoryforCompany,
  payment,
  auth,
}) => {
  const location = useLocation();

  // pay now section visiblity state
  const [isPayNowBoxOpen, setIsPayNowBoxOpen] = useState(false);

  // selected payment type (one-time or recurring)
  const [isOneTimePaymentSelected, setIsOneTimePaymentSelected] =
    useState(true);



  const [value, setValue] = React.useState(0);

  const setTabChangeValue = (newValue) => {
    if (newValue === 0) {
      getAllPaymentHistoryforCompany(auth.companyId);
    }
    setValue(newValue);
  };

  useEffect(() => {
    getSubscriptionDetails({
      companyId: auth.companyId && auth.companyId,
      serviceId: parseInt(serviceId),
    });
    getAllPaymentHistoryforCompany(auth.companyId && auth.companyId);
  }, [location, auth]);


  return (
    <div className={styles.paymentContainer}>
      <h2>Billing and Payment</h2>

      <div className={styles.paymentTabContainer}>
   
          <div className={styles.paymentContentWrapper}>
            <div className={styles.paymentMenuContainer}>
              <div
                className={`${styles.paymentMenuItem} ${value === 0 ? styles.paymentMenuItemActive : ""}`}
                onClick={() => setTabChangeValue(0)}
              >
                <HomeIcon className={styles.paymentMenuIcon} />
                <span className={styles.paymentMenuText}>Overview</span>
              </div>
              <div
                className={`${styles.paymentMenuItem} ${value === 1 ? styles.paymentMenuItemActive : ""}`}
                onClick={() => setTabChangeValue(1)}
              >
                <WorkspacePremiumIcon className={styles.paymentMenuIcon} />
                <span className={styles.paymentMenuText}>Membership</span>
              </div>
              <div
                className={`${styles.paymentMenuItem} ${value === 2 ? styles.paymentMenuItemActive : ""}`}
                onClick={() => setTabChangeValue(2)}
              >
                <CreditCardIcon className={styles.paymentMenuIcon} />
                <span className={styles.paymentMenuText}>Manage Payment</span>
              </div>
            </div>
            <div className={styles.paymentContentArea}>
              {value === 0 && (
                <OverviewTab
                  setTabChangeValue={setTabChangeValue}
                  setValue={setValue}

                />
              )}
              {value === 1 && (
          
                <MembershipTab
                  setTabChangeValue={setTabChangeValue}
                  setValue={setValue}
                  isPayNowBoxOpen={isPayNowBoxOpen}
                  setIsPayNowBoxOpen={setIsPayNowBoxOpen}
                />
              )}
              {value === 2 && (
                <ManagePaymentTab
                  setTabChangeValue={setTabChangeValue}
                  setValue={setValue}
                  isPayNowBoxOpen={isPayNowBoxOpen}
                  setIsPayNowBoxOpen={setIsPayNowBoxOpen}
                />
              )}
            </div>
          </div>
      </div>
    </div>
  );
};

Payment.propTypes = {
  getSubscriptionUser: PropTypes.func.isRequired,
  getSubscriptionDetails: PropTypes.func.isRequired,
  getAllPaymentHistoryforCompany: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  payment: state.paymentState,
  auth: state.authState,
});

export default connect(mapStateToProps, {
  getSubscriptionUser,
  getSubscriptionDetails,
  getAllPaymentHistoryforCompany,
})(Payment);
